import { OverflowMenu } from "@carbon/react";
import { FC, useState } from "react";

import { AuthorizedMenu, AuthorizedOverflowMenuItem } from "src/authentication/AuthorizedMenu";
import { Scope, ScopeResource } from "src/authentication/PermissionsProvider";
import { ModalTransition } from "src/components/Modal";
import { useT } from "src/internationalization";
import { Rule } from "src/types/rule";

import { DeleteRuleModal } from "./DeleteRuleModal";
import { UpdateRuleModal } from "./UpdateRuleModal";

type RuleActionsMenuProps = {
  rule: Rule;
  rules: Rule[];
};

export const RuleActionsMenu: FC<RuleActionsMenuProps> = ({ rule, rules }) => {
  const t = useT();
  const [ruleIdToUpdate, setRuleIdToUpdate] = useState<string | null>(null);
  const ruleToUpdate = rules.find((r) => r.id === ruleIdToUpdate) ?? null;
  const [ruleIdToDelete, setRuleIdToDelete] = useState<string | null>(null);
  const ruleToDelete = rules.find((r) => r.id === ruleIdToDelete) ?? null;
  const isPredefined = rule?.implementationType === "predefined";

  return (
    <>
      <AuthorizedMenu
        menuItemsPermissions={[
          { resource: ScopeResource.RULE, scopes: [Scope.EDIT] },
          { resource: ScopeResource.RULE, scopes: [Scope.DELETE] },
        ]}
      >
        <OverflowMenu flipped>
          <AuthorizedOverflowMenuItem
            requiredPermissions={[{ resource: ScopeResource.RULE, scopes: [Scope.EDIT] }]}
            itemText={t("general.actions.edit")}
            onClick={() => setRuleIdToUpdate(rule.id)}
            disabled={isPredefined}
          />

          <AuthorizedOverflowMenuItem
            requiredPermissions={[{ resource: ScopeResource.RULE, scopes: [Scope.DELETE] }]}
            itemText={t("general.actions.delete")}
            onClick={() => setRuleIdToDelete(rule.id)}
            disabled={isPredefined}
            isDelete={true}
          />
        </OverflowMenu>
      </AuthorizedMenu>

      <ModalTransition>
        {ruleToDelete && (
          <DeleteRuleModal ruleToDelete={ruleToDelete} onClose={() => setRuleIdToDelete(null)} />
        )}
      </ModalTransition>
      <ModalTransition>
        {ruleToUpdate && (
          <UpdateRuleModal
            rule={ruleToUpdate}
            rules={rules}
            onClose={() => setRuleIdToUpdate(null)}
          />
        )}
      </ModalTransition>
    </>
  );
};
